import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	hasFeatureIslandCategoryContext?: boolean;

	isEdited: boolean;
	hasError: boolean;
	geoLocation: ForAutoGenerator<
		| {
				lat?: number | null | undefined;
				lon?: number | null | undefined;
		  }
		| null
		| undefined,
		""
	>;
	onSetLatitude: (number: number | undefined) => void;
	onSetLongitude: (number: number | undefined) => void;

	title?: string;
	guide?: string;
};

export const QuestionGeoLocation = ({
	hasFeatureIslandCategoryContext = true,

	isEdited, //
	hasError,

	geoLocation,
	onSetLatitude,
	onSetLongitude,

	title,
	guide,
}: Props) => {
	return (
		<>
			{hasFeatureIslandCategoryContext ? (
				<FeatureIslandCategoryQuestionForMain
					required={false}
					title={title ?? "緯度・経度"}
					guide={
						guide ??
						"ホテルポリシーで設定した以外のアメニティや設備が存在する場合は、こちらで追加設定が可能です。"
					}
					isEdited={isEdited}
					hasError={hasError}
					inputChildren={
						<div className="flex flex-col gap-y-8 ">
							<div className="flex flex-col gap-y-4">
								<QuestionSectionWrapper>
									<p className="text-sm">緯度：</p>
									<InputNumberField
										value={geoLocation?.lat?.value ?? undefined}
										handleInput={onSetLatitude}
										needsDecimal
										errorMessage={geoLocation?.lat?.error}
									/>
									<p className="text-sm">度</p>
								</QuestionSectionWrapper>
								<QuestionSectionWrapper>
									<p className="text-sm">経度：</p>
									<InputNumberField
										value={geoLocation?.lon?.value ?? undefined}
										handleInput={onSetLongitude}
										needsDecimal
										errorMessage={geoLocation?.lon?.error}
									/>
									<p className="text-sm">度</p>
								</QuestionSectionWrapper>
							</div>
						</div>
					}
				/>
			) : (
				<QuestionForMain
					required={false}
					title={title ?? "緯度・経度"}
					guide={
						guide ??
						"ホテルポリシーで設定した以外のアメニティや設備が存在する場合は、こちらで追加設定が可能です。"
					}
					inputChildren={
						<div className="flex flex-col gap-y-8 ">
							<div className="flex flex-col gap-y-4">
								<QuestionSectionWrapper>
									<p className="text-sm">緯度：</p>
									<InputNumberField
										value={geoLocation?.lat?.value ?? undefined}
										handleInput={onSetLatitude}
										needsDecimal
										errorMessage={geoLocation?.lat?.error}
									/>
									<p className="text-sm">度</p>
								</QuestionSectionWrapper>
								<QuestionSectionWrapper>
									<p className="text-sm">経度：</p>
									<InputNumberField
										value={geoLocation?.lon?.value ?? undefined}
										handleInput={onSetLongitude}
										needsDecimal
										errorMessage={geoLocation?.lon?.error}
									/>
									<p className="text-sm">度</p>
								</QuestionSectionWrapper>
							</div>
						</div>
					}
				/>
			)}
		</>
	);
};

QuestionGeoLocation.displayName = "QuestionGeoLocation";
